﻿export interface IPagingInfo {
    page: number;
    pageSize: number;
    totalItems: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

const DEFAULT_PAGE_SIZE = 50;
const INITIAL_PAGE = 1;

export class PagedResult<T> {
    readonly items: T[];
    readonly pagingInfo: IPagingInfo;

    constructor(items: T[], pagingInfo: IPagingInfo) {
        this.items = items;
        this.pagingInfo = pagingInfo;
    }

    static createEmpty<T>(): PagedResult<T> {
        return new PagedResult<T>([], {
            page: INITIAL_PAGE,
            pageSize: DEFAULT_PAGE_SIZE,
            totalItems: 0,
            totalPages: 0,
            hasNextPage: false,
            hasPreviousPage: false
        });
    }

    static fromResponse<T>(
        items: T[],
        page: number,
        pageSize: number,
        totalItems: number
    ): PagedResult<T> {
        const totalPages = Math.ceil(totalItems / pageSize);

        return new PagedResult<T>(items, {
            page,
            pageSize,
            totalItems,
            totalPages,
            hasNextPage: page < totalPages,
            hasPreviousPage: page > 1
        });
    }
}